import { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setTabOnFocus, toggleRightDrawer, handleSnackBar, setReRender } from '../../store/global/actions';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import Divider from '@material-ui/core/Divider';
import { Grid } from '@material-ui/core';
import TransactionConfiguration from '../molecules/simulations/TransactionConfiguration';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import DeleteSimulationTransactionAlert from '../molecules/alerts/DeleteSimulationTransactionAlert';

export default function SimulationTransaction({ element }) {
    const dispatch = useDispatch();
    const [openTab, setOpenTab] = useState(0);
    const detailsBC = [
        { label: 'Simulation', url: null },
        { label: element.name, url: null }
    ];
    const [showDeleteEventAlert, setShowDeleteEventAlert] = useState(false);



    const onClose = () => {
        dispatch(toggleRightDrawer());

    }

    const onCompletion = (type, action) => {

        if (action != undefined) {

            switch (action) {
                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    break;

                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    break;

            }
        }

    }

    const handleSimulationTransactionDeleteEvent = () => {
        setShowDeleteEventAlert(true);
    }


    return (
        <>
            <AppBar position="static">
                <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="SimulationTransactionTabs">
                    <Tab label="Configuration" />
                </Tabs>
            </AppBar>


            <TabPanel value={openTab} index={0} >
                <Grid container direction={"row"} spacing={2}>
                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>


                    <Grid item xs={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Tooltip title="Delete Transaction" arrow>
                            <IconButton onClick={(e) => handleSimulationTransactionDeleteEvent()}>
                                <DeleteIcon color="secondary" />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>

                <Divider style={marginBottomForBreadCrumb} />

                <TransactionConfiguration element={element} onCompletion={onCompletion} onClose={onClose} />
                {showDeleteEventAlert && <DeleteSimulationTransactionAlert element={element} onCompletion={onCompletion} onClose={onClose} />}

            </TabPanel>
        </>
    )


}